import React from 'react'
import { Button, Modal, Descriptions, Divider } from 'antd'
import { GENDER_ENUM, MARITAL_STATUS_ENUM, EDUCATION_ENUM } from '@/utils/consts';
import moment from 'moment';
import { print } from "@/utils/printUtils";
import html2pdf from '@/utils/html2pdf';
import styles from './index.less'

export default function HealthyPrintModal(props) {

  const { visible, onCancel, info, result, dppResult } = props;

  let fatherInfo = {};
  let motherInfo = {}
  info&&info.customerFamilies&&info.customerFamilies.forEach(_=> {
    if(_.relation === '父亲'){
      fatherInfo = {..._};
    }else if(_.relation === '母亲'){
      motherInfo = {..._};
    }
  
  })

  const handlePrint = ()=>{
      const printContent = document.getElementById("healthy-print").parentNode;
      setTimeout(() => {
        print(printContent);
      }, 2000);
  }

  const handlePdf = ()=>{
    const printContent = document.getElementById("healthy-print").parentNode;
    if(printContent){
      html2pdf(printContent);
    }
  }

  

  const footer = (
    <>
    <Button onClick={onCancel}>关闭</Button>
    <Button onClick={handlePrint} type='primary'>打印</Button>
    <Button onClick={handlePdf} type='primary'>导出</Button>
    </>
  )

  //
  const oneVisible = result.chiefComplaint||result.historyOfPresentIllness||result.sleepState||result.dietState||result.performanceState||
  result.riskEvaluation||result.attitudeTowardsDisease||result.significantMedicalHistory||result.allergicHistory||result.hereditaryDisease||
  result.paternalPsychiatricHistory||result.maternalPsychiatricHistory||((result.menstrualHistoryReq&&result.menstrualHistoryReq.menarcheAge)||
  (result.menstrualHistoryReq&&result.menstrualHistoryReq.menstrualPeriod)||
  (result.menstrualHistoryReq&&result.menstrualHistoryReq.menstrualCycle)||
  (result.menstrualHistoryReq&&result.menstrualHistoryReq.lastMenstrualCycle))||(result.menstrualHistoryReq&&result.menstrualHistoryReq.regularMenstruation)||result.physiologySummarize

  const twoVisible = result.subjectiveEvaluationJudgment||result.emotionalCharacteristics||result.questionnaireResults||(result.howManyChild||result.birthStatus)||
  result.physicalGrowth||result.feelingSystemDisorders||result.historyOfNervousSystemDisease||result.importantChildhoodExperiencesAndMemories||
  result.hobby||result.schoolRecord||result.schoolRecordOverview||(result.badAddiction||result.otherBadAddiction)||result.badAddictionOverview||
  result.otherPersonalLife||result.psychologySummarize;

  const threeVisible = (result.fatherInformationReq&&(result.fatherInformationReq.life||result.fatherInformationReq.personalityCharacteristic||result.fatherInformationReq.emotionalCharacteristic))||(result.fatherInformationReq&&result.fatherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns)||
  (result.fatherInformationReq&&result.fatherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns)||(result.motherInformationReq&&(result.motherInformationReq&&result.motherInformationReq.life||result.motherInformationReq&&result.motherInformationReq.personalityCharacteristic||result.motherInformationReq&&result.motherInformationReq.emotionalCharacteristic))||
  (result.motherInformationReq&&result.motherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns)||(result.motherInformationReq&&result.motherInformationReq.parentInteractionModeDescription)||
  result.parentingStyles||result.descriptionOfParentingStyle||result.relationshipWithFather||result.relationshipWithMother||result.relationshipWithSiblings||
  result.generalCharacterization||result.psychologySummarize;

  const fourVisible = (result.ageOfLove||result.numberOfLove)||result.briefHistoryOfLove||(result.ageOfMarriage||result.historyOfMarriage)||(result.spouseSituation||result.ageOfSpouseDeath||result.causeOfDeath)||result.briefHistoryOfMarriage||
  (result.spousePersonalityCharacteristics||result.spousalEmotionalCharacteristics)||result.spouseInterpersonalInteractionMode||result.loveRelationshipOrMarriageRelationship||
  (result.livingWithElders||result.relationshipWithElders)||result.relationshipWithEldersDescription||(result.whetherFertility||result.whetherFertility)||(result.livingWithJunior||result.relationshipWithJunior)||
  result.relationshipWithJuniorDescription||result.generalCharacterization||result.socialSummarize;

  const fiveVisible = result.recentChange||result.overviewOfWorkOrStudyAbility||result.recentRelationshipsWithFriendsAndColleagues||result.recentRelationshipsWithFriendsAndColleaguesDescription||
  result.generalCharacterDescription||result.socialSummarize;

  return (
    <Modal
      width={800}
      visible={visible}
      onCancel={onCancel}
      footer={footer}
      className={styles.healthyPrintModal}
      maskClosable={false}
      destroyOnClose
      closable={false}
    >
      <div id='healthy-print'>
      <h1 style={{width:'100%',textAlign:'center',borderTop:'1px solid #e8e8e8',borderLeft:'1px solid #e8e8e8',borderRight:'1px solid #e8e8e8',margin:0,padding:15,color:'#1DADE9',fontSize:24,fontWeight:'bold'}}>健康档案</h1>
      <Descriptions title={info.name} style={{backgroundColor:'#002E59',padding:'20px 10px',borderLeft:'1px solid #e8e8e8',borderRight:'1px solid #e8e8e8',borderBottom:'1px solid #e8e8e8'}} className='descriptions-first'>
            <Descriptions.Item style={{color:'#fff'}}  label="性别">{info.gender && GENDER_ENUM.some(_ => _.value === info.gender) ? (GENDER_ENUM.find(_ => _.value === info.gender) || {}).label : ''}</Descriptions.Item>
            <Descriptions.Item  label="年龄">{info.age}</Descriptions.Item>
            <Descriptions.Item  label="身高">{info.height}cm</Descriptions.Item>
            <Descriptions.Item  label="电话">{info.phone}</Descriptions.Item>
            <Descriptions.Item  label="微信">{info.weixinId}</Descriptions.Item>
            <Descriptions.Item  label="体重">{info.weight}kg</Descriptions.Item>
            <Descriptions.Item  label="婚姻状态">{info.maritalStatus && MARITAL_STATUS_ENUM.some(_ => _.value === info.maritalStatus) ? (MARITAL_STATUS_ENUM.find(_ => _.value === info.maritalStatus) || {}).label : ''}</Descriptions.Item>
            <Descriptions.Item  label="学历">{info.education && EDUCATION_ENUM.some(_ => _.value === info.education) ? (EDUCATION_ENUM.find(_ => _.value === info.education) || {}).label : ''}</Descriptions.Item>
            <Descriptions.Item  label="职业">{info.occupation}</Descriptions.Item>
            <Descriptions.Item  label="居住城市">{info.address}</Descriptions.Item>
            <Descriptions.Item  label="心理顾问">{info.consultantDoctorName}</Descriptions.Item>
            <Descriptions.Item  label="私人管家">{info.personalDoctorName}</Descriptions.Item>
        </Descriptions>

        {(fatherInfo.name||fatherInfo.telephone||fatherInfo.age||fatherInfo.occupation||motherInfo.name||motherInfo.telephone||motherInfo.age||motherInfo.occupation)&&
          <Descriptions column={2} title='家庭信息' style={{padding:'20px 10px',borderLeft:'1px solid #e8e8e8',borderRight:'1px solid #e8e8e8',borderBottom:'1px solid #e8e8e8'}}>
            {(fatherInfo.name||fatherInfo.telephone||fatherInfo.age||fatherInfo.occupation)&&<Descriptions.Item  label="父亲">{`${fatherInfo.name?fatherInfo.name + ' | ':''}${fatherInfo.telephone?fatherInfo.telephone + ' | ':''}${fatherInfo.age?fatherInfo.age + ' | ':''}${fatherInfo.occupation||''}`}</Descriptions.Item>}
            {(motherInfo.name||motherInfo.telephone||motherInfo.age||motherInfo.occupation)&&<Descriptions.Item  label="母亲">{`${motherInfo.name?motherInfo.name + ' | ':''}${motherInfo.telephone?motherInfo.telephone + ' | ':''}${motherInfo.age?motherInfo.age + ' | ':''}${motherInfo.occupation||''}`}</Descriptions.Item>}
          </Descriptions>
        }

        {info.coreRequirement&&
        <Descriptions title='需求描述' style={{padding:'20px 10px',borderLeft:'1px solid #e8e8e8',borderRight:'1px solid #e8e8e8',borderBottom:'1px solid #e8e8e8'}}>
          <Descriptions.Item  label="核心诉求描述">{info.coreRequirement}</Descriptions.Item>
        </Descriptions>
        }

        {(oneVisible||twoVisible||threeVisible||fourVisible||fiveVisible)&&
        
            <Descriptions column={1} title='BPS首诊档案' style={{padding:'20px 10px',borderLeft:'1px solid #e8e8e8',borderRight:'1px solid #e8e8e8',borderBottom:'1px solid #e8e8e8'}}>
            {oneVisible&&
              <>
                <div className="summary-label-medal" style={{color:'#333333',fontSize:14,paddingBottom:10}}>一、临床症状（第一次症状出现至今的情况）（情绪、睡眠、饮食等）</div>
                    <div className="summary-content">
                      <Descriptions column={1}>
                        {result.chiefComplaint&&<Descriptions.Item label="主诉">{result.chiefComplaint}</Descriptions.Item>}
                        {result.historyOfPresentIllness&&<Descriptions.Item label="现病史">{result.historyOfPresentIllness}</Descriptions.Item>}
                        {result.sleepState&&<Descriptions.Item label="睡眠状态">{result.sleepState}</Descriptions.Item>}
                        {result.dietState&&<Descriptions.Item label="饮食状况">{result.dietState}</Descriptions.Item>}
                        {result.performanceState&&<Descriptions.Item label="生活自理">{result.performanceState}</Descriptions.Item>}
                        {result.riskEvaluation&&<Descriptions.Item label="风险评估">{result.riskEvaluation}</Descriptions.Item>}
                        {result.attitudeTowardsDisease&&<Descriptions.Item label="对疾病认识态度">{result.attitudeTowardsDisease}</Descriptions.Item>}
                        {result.significantMedicalHistory&&<Descriptions.Item label="重大病史">{result.significantMedicalHistory}</Descriptions.Item>}
                        {result.allergicHistory&&<Descriptions.Item label="食物药物过敏史">{result.allergicHistory}</Descriptions.Item>}
                      
                        {result.hereditaryDisease&&<Descriptions.Item label="遗传疾病">{result.hereditaryDisease}</Descriptions.Item>}
                        {result.paternalPsychiatricHistory&&<Descriptions.Item label="父系精神病史">{result.paternalPsychiatricHistory}</Descriptions.Item>}
                        {result.maternalPsychiatricHistory&&<Descriptions.Item label="母系精神病史">{result.maternalPsychiatricHistory}</Descriptions.Item>}
                    
                        {((result.menstrualHistoryReq&&result.menstrualHistoryReq.menarcheAge)||
                        (result.menstrualHistoryReq&&result.menstrualHistoryReq.menstrualPeriod)||
                        (result.menstrualHistoryReq&&result.menstrualHistoryReq.menstrualCycle)||
                        (result.menstrualHistoryReq&&result.menstrualHistoryReq.lastMenstrualCycle))&&
                        <Descriptions.Item label="月经史">
                          {[
                            result.menstrualHistoryReq&&result.menstrualHistoryReq.menarcheAge
                              ? `初潮${result.menstrualHistoryReq.menarcheAge}岁`
                              : '',
                              result.menstrualHistoryReq&&result.menstrualHistoryReq.menstrualPeriod
                              ? `行经期${result.menstrualHistoryReq.menstrualPeriod}天`
                              : '',
                              result.menstrualHistoryReq&&result.menstrualHistoryReq.menstrualCycle
                              ? `月经周期${result.menstrualHistoryReq.menstrualCycle}天`
                              : '',
                              result.menstrualHistoryReq&&result.menstrualHistoryReq.lastMenstrualCycle
                              ? `末次月经日期${moment(result.menstrualHistoryReq.lastMenstrualCycle).format(
                                'YYYY-MM-DD'
                              )}`
                              : '',
                          ]
                            .filter(_ => _)
                            .join(',')}
                        </Descriptions.Item>
                        }
                        {result.menstrualHistoryReq&&result.menstrualHistoryReq.regularMenstruation&&<Descriptions.Item label="平素月经情况">{result.menstrualHistoryReq&&result.menstrualHistoryReq.regularMenstruation}</Descriptions.Item>}
                        {result.physiologySummarize&&<Descriptions.Item label="概念化总结">{result.physiologySummarize}</Descriptions.Item>}
                      </Descriptions>
                    </div>
                </>
                }
            
                {twoVisible&&<Descriptions.Item className='didver-cutomer' style={{border:'1px solid #e8e8e8'}}></Descriptions.Item>}
                
                {twoVisible&&
                  <>
                    <div className="summary-label-medal" style={{color:'#333333',fontSize:14,paddingBottom:10}}>二、人格：性格和成长经历的情况（目前年龄往回退3年前或者18岁之前的情况）</div>
                    <div className="summary-content">
                      <Descriptions column={1}>
                        {result.subjectiveEvaluationJudgment&&<Descriptions.Item label="主观评估判断">{result.subjectiveEvaluationJudgment}</Descriptions.Item>}
                        {result.emotionalCharacteristics&&<Descriptions.Item label="情绪特点">{result.emotionalCharacteristics}</Descriptions.Item>}
                        {result.questionnaireResults&&<Descriptions.Item label="其他量表结果参考">{result.questionnaireResults}</Descriptions.Item>}
                        {(result.howManyChild||result.birthStatus)&&
                          <Descriptions.Item label="母孕期">
                          {result.howManyChild ? `第${result.howManyChild}胎` : ''}
                          {result.birthStatus}
                        </Descriptions.Item>
                        }
                        {result.physicalGrowth&&<Descriptions.Item label="生长发育(0-6岁左右)体格发育">{result.physicalGrowth}</Descriptions.Item>}
                        
                        {result.feelingSystemDisorders&&<Descriptions.Item label="感统失调">{result.feelingSystemDisorders}</Descriptions.Item>}
                        {result.historyOfNervousSystemDisease&&<Descriptions.Item label="神经系统疾病史">{result.historyOfNervousSystemDisease}</Descriptions.Item>}
                        {result.importantChildhoodExperiencesAndMemories&&<Descriptions.Item label="重要的童年经历/记忆">{result.importantChildhoodExperiencesAndMemories}</Descriptions.Item>}
                        {result.hobby&&<Descriptions.Item label="兴趣爱好">{result.hobby}</Descriptions.Item>}

                        {result.schoolRecord&&<Descriptions.Item label="学习成绩">{result.schoolRecord}</Descriptions.Item>}
                        {result.schoolRecordOverview&&<Descriptions.Item label="重要经历概述">{result.schoolRecordOverview}</Descriptions.Item>}

                        {(result.badAddiction||result.otherBadAddiction)&&
                          <Descriptions.Item label="不良嗜好">
                            {result.badAddiction}
                            {result.otherBadAddiction}
                          </Descriptions.Item>
                        }
                        {result.badAddictionOverview&&<Descriptions.Item label="重要经历概述">{result.badAddictionOverview}</Descriptions.Item>}
                        {result.otherPersonalLife&&<Descriptions.Item label="其他">{result.otherPersonalLife}</Descriptions.Item>}
                        {result.psychologySummarize&&<Descriptions.Item label="概念化总结">{result.psychologySummarize}</Descriptions.Item>}
                      </Descriptions>
                    </div>
                  </>
                }

                {threeVisible&&<Descriptions.Item className='didver-cutomer' style={{border:'1px solid #e8e8e8'}}></Descriptions.Item>}
                
                {threeVisible&&
                  <>
                    <div className="summary-label-medal" style={{color:'#333333',fontSize:14,paddingBottom:10}}>三、原生家庭（目前年龄往回退3年前或者18岁之前的情况）（家庭环境、教育方式等）</div>
                      <div className="summary-content">
                        <Descriptions column={1}>
                          {result.fatherInformationReq&&(result.fatherInformationReq.life||result.fatherInformationReq.personalityCharacteristic||result.fatherInformationReq.emotionalCharacteristic)&&
                          <Descriptions.Item label="父亲信息">
                            {[
                              result.fatherInformationReq&&result.fatherInformationReq.life,
                              result.fatherInformationReq&&result.fatherInformationReq.personalityCharacteristic,
                              result.fatherInformationReq&&result.fatherInformationReq.emotionalCharacteristic,
                            ]
                              .filter(_ => _)
                              .join('，')}
                          </Descriptions.Item>
                          }
                          {result.fatherInformationReq&&result.fatherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns&&
                            <Descriptions.Item label="人际互动模式">
                              {result.fatherInformationReq&&result.fatherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns}
                            </Descriptions.Item>
                          }
                          {result.fatherInformationReq&&result.fatherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns&&
                            <Descriptions.Item label="个人重要经历">
                              {result.fatherInformationReq&&result.fatherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns}
                            </Descriptions.Item>
                          }
                          {result.motherInformationReq&&(result.motherInformationReq&&result.motherInformationReq.life||result.motherInformationReq&&result.motherInformationReq.personalityCharacteristic||result.motherInformationReq&&result.motherInformationReq.emotionalCharacteristic)&&
                            <Descriptions.Item label="母亲信息">
                              {[
                                result.motherInformationReq&&result.motherInformationReq.life,
                                result.motherInformationReq&&result.motherInformationReq.personalityCharacteristic,
                                result.motherInformationReq&&result.motherInformationReq.emotionalCharacteristic,
                              ]
                                .filter(_ => _)
                                .join('，')}
                            </Descriptions.Item>
                          }
                          {result.motherInformationReq&&result.motherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns&&
                            <Descriptions.Item label="人际互动模式">
                              {result.motherInformationReq&&result.motherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns}
                            </Descriptions.Item>
                          }
                          {result.motherInformationReq&&result.motherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns&&
                            <Descriptions.Item label="个人重要经历">
                              {result.motherInformationReq&&result.motherInformationReq.briefDescriptionOfInterpersonalInteractionPatterns}
                            </Descriptions.Item>
                          }
                          {result.motherInformationReq&&result.motherInformationReq.parentInteractionModeDescription&&
                            <Descriptions.Item label="父母互动模式">
                              {result.motherInformationReq&&result.motherInformationReq.parentInteractionModeDescription}
                            </Descriptions.Item>
                          }
                      
                          {/* <Item label="相处方式">{result.getAlongWay}</Item>
                          <Item label="简要描述">{result.parentingStyleDescription}</Item> */}
                          {result.parentingStyles&&<Descriptions.Item label="教养方式">{result.parentingStyles}</Descriptions.Item>}
                          {result.descriptionOfParentingStyle&&<Descriptions.Item label="简要描述">{result.descriptionOfParentingStyle}</Descriptions.Item>}
                          {result.relationshipWithFather&&<Descriptions.Item label="与父亲关系">{result.relationshipWithFather}</Descriptions.Item>}
                          {result.relationshipWithMother&&<Descriptions.Item label="与母亲关系">{result.relationshipWithMother}</Descriptions.Item>}
                          {result.relationshipWithSiblings&&<Descriptions.Item label="与兄弟姐妹关系">{result.relationshipWithSiblings}</Descriptions.Item>}
                      
                          {result.generalCharacterization&&<Descriptions.Item label="简要描述">{result.generalCharacterization}</Descriptions.Item>}
                          {result.psychologySummarize&&<Descriptions.Item label="概念化总结">{result.psychologySummarize}</Descriptions.Item>}
                        </Descriptions>
                      </div>
                  </>
                }

                {fourVisible&&<Descriptions.Item className='didver-cutomer' style={{border:'1px solid #e8e8e8'}}></Descriptions.Item>}
                

                {fourVisible&&
                  <>
                    <div className="summary-label-medal" style={{color:'#333333',fontSize:14,paddingBottom:10}}>四、婚姻家庭适应（通常3年内的主要困扰）（家庭环境、教育方式等）</div>
                    <div className="summary-content">
                      <Descriptions column={1}>
                        {(result.ageOfLove||result.numberOfLove)&&
                          <Descriptions.Item label="恋爱史">
                            {[
                              result.ageOfLove
                                ? `${result.ageOfLove}岁开始恋爱`
                                : '',
                              result.numberOfLove
                                ? `恋爱${result.numberOfLove}次`
                                : '',
                            ]
                              .filter(_ => _)
                              .join(',')}
                          </Descriptions.Item>
                        }
                        {result.briefHistoryOfLove&&<Descriptions.Item label="简述恋爱史">{result.briefHistoryOfLove}</Descriptions.Item>}
                        
                        {(result.ageOfMarriage||result.historyOfMarriage)&&
                          <Descriptions.Item label="婚恋情况">
                            {[
                              result.ageOfMarriage
                                ? `${result.ageOfMarriage}岁结婚`
                                : '',
                              result.historyOfMarriage
                                ? `婚史${result.historyOfMarriage}年`
                                : '',
                            ]
                              .filter(_ => _)
                              .join(',')}
                          </Descriptions.Item>
                        }
                        {(result.spouseSituation||result.ageOfSpouseDeath||result.causeOfDeath)&&
                        <Descriptions.Item label="配偶">
                          {[
                            result.spouseSituation
                              ? `${result.spouseSituation}`
                              : '',
                            result.ageOfSpouseDeath
                              ? `死亡年龄${result.ageOfSpouseDeath}`
                              : '',
                            result.causeOfDeath
                              ? `${result.causeOfDeath}`
                              : '',
                          ]
                            .filter(_ => _)
                            .join(',')}
                        </Descriptions.Item>
                        }
                        {result.briefHistoryOfMarriage&&<Descriptions.Item label="简述婚姻史">{result.briefHistoryOfMarriage}</Descriptions.Item>}
                        {(result.spousePersonalityCharacteristics||result.spousalEmotionalCharacteristics)&&
                          <Descriptions.Item label="当前配偶／恋爱对象">
                            {[
                              result.spousePersonalityCharacteristics
                                ? `人格特点：${result.spousePersonalityCharacteristics}`
                                : '',
                              result.spousalEmotionalCharacteristics
                                ? `情绪特点：${result.spousalEmotionalCharacteristics}`
                                : '',
                            ]
                              .filter(_ => _)
                              .join(',')}
                          </Descriptions.Item>
                        }
                        {result.spouseInterpersonalInteractionMode&&<Descriptions.Item label="人际互动模式">{result.spouseInterpersonalInteractionMode}</Descriptions.Item>}
                        {result.loveRelationshipOrMarriageRelationship&&<Descriptions.Item label="恋爱关系／夫妻关系">{result.loveRelationshipOrMarriageRelationship}</Descriptions.Item>}
                        
                        {(result.livingWithElders||result.relationshipWithElders)&&
                          <Descriptions.Item label="新家庭融合情况">
                            {[
                              result.livingWithElders
                                ? `与老人：${result.livingWithElders}`
                                : '',
                              result.relationshipWithElders
                                ? `相处关系：${result.relationshipWithElders}`
                                : '',
                            ]
                              .filter(_ => _)
                              .join(',')}
                          </Descriptions.Item>
                        }
                        {result.relationshipWithEldersDescription&&<Descriptions.Item label="情况简述">{result.relationshipWithEldersDescription}</Descriptions.Item>}
                        {(result.whetherFertility||result.whetherFertility)&&
                          <Descriptions.Item label="生育">
                            {result.whetherFertility === '有'
                              ? `${
                              result.numberOfSon
                                ? `儿子${result.numberOfSon}名${
                                result.ageOfSon ? `,${result.ageOfSon}岁` : ''
                                }`
                                : ''
                              }${result.numberOfSon ? '；' : ''}${
                              result.numberOfDaughter
                                ? `女儿${result.numberOfDaughter}名${
                                result.ageOfDaughter ? `,${result.ageOfDaughter}岁` : ''
                                }`
                                : ''
                              }`
                              : result.whetherFertility === '无'
                                ? '无'
                                : ''}
                          </Descriptions.Item>
                        }
                        {(result.livingWithJunior||result.relationshipWithJunior)&&
                          <Descriptions.Item label="亲子关系">
                            {[
                              result.livingWithJunior
                                ? `与子女：${result.livingWithJunior}`
                                : '',
                              result.relationshipWithJunior
                                ? `相处关系：${result.relationshipWithJunior}`
                                : '',
                            ]
                              .filter(_ => _)
                              .join(',')}
                          </Descriptions.Item>
                        }
                        {result.relationshipWithJuniorDescription&&<Descriptions.Item label="情况简述">{result.relationshipWithJuniorDescription}</Descriptions.Item>}
                        {result.generalCharacterization&&<Descriptions.Item label="简要概述">{result.generalCharacterization}</Descriptions.Item>}
                        {result.socialSummarize&&<Descriptions.Item label="概念化总结">{result.socialSummarize}</Descriptions.Item>}
                      </Descriptions>
                    </div>
                  </>
                }
                
                {fiveVisible&&<Descriptions.Item className='didver-cutomer' style={{border:'1px solid #e8e8e8'}}></Descriptions.Item>}


                {fiveVisible&&
                  <>
                    <div className="summary-label-medal" style={{color:'#333333',fontSize:14,paddingBottom:10}}>五、社会事件（通常3年内的主要困扰）（学业&工作状况及所遇挫折、人际等问题）</div>
                      <div className="summary-content">
                        <Descriptions column={1}>
                          {result.recentChange&&<Descriptions.Item label="工作学习状态">{result.recentChange}</Descriptions.Item>}
                          {result.overviewOfWorkOrStudyAbility&&<Descriptions.Item label="简要概述">{result.overviewOfWorkOrStudyAbility}</Descriptions.Item>}
                          {result.recentRelationshipsWithFriendsAndColleagues&&<Descriptions.Item label="人际状况">{result.recentRelationshipsWithFriendsAndColleagues}</Descriptions.Item>}
                          {result.recentRelationshipsWithFriendsAndColleaguesDescription&&
                            <Descriptions.Item label="简要概述">
                              {result.recentRelationshipsWithFriendsAndColleaguesDescription}
                            </Descriptions.Item>
                          }
                          {result.generalCharacterDescription&&<Descriptions.Item label="简要概述">{result.generalCharacterDescription}</Descriptions.Item>}
                          {result.socialSummarize&&<Descriptions.Item label="概念化总结">{result.socialSummarize}</Descriptions.Item>}
                        </Descriptions>
                      </div>
                  </>
                }

                {/* {fiveVisible&&<Descriptions.Item className='didver-cutomer' style={{border:'1px solid #e8e8e8'}}></Descriptions.Item>} */}

                
                </Descriptions>
            }

            {dppResult.dppCycleTherapyProductRespList&&dppResult.dppCycleTherapyProductRespList.length > 0&&
              <Descriptions column={1} title='DPP循程治疗方案' style={{padding:'20px 10px',borderLeft:'1px solid #e8e8e8',borderRight:'1px solid #e8e8e8',borderBottom:'1px solid #e8e8e8'}}>
                {dppResult.dppCycleTherapyProductRespList&&dppResult.dppCycleTherapyProductRespList.map((item,index)=>{
                  return <>
                          <Descriptions.Item label="">{item.category}</Descriptions.Item>
                          <Descriptions.Item label="项目名称">{dppResult.dppCycleTherapyProductRespList&&dppResult.dppCycleTherapyProductRespList[0]&&`${item.name} | ${item.serviceDuration + '分钟'} | ${item.quantity + '次'}${item.executorName?' | ' + item.executorName + '（执行人）':''}`}</Descriptions.Item>
                          <Descriptions.Item label="">{item.description}</Descriptions.Item>
                          {index !== dppResult.dppCycleTherapyProductRespList.length - 1&&<Descriptions.Item className='didver-cutomer' style={{border:'1px solid #e8e8e8'}}></Descriptions.Item>}
                          
                        </>
                })}
              </Descriptions>
            }
            </div>
    </Modal>
  )
}
